import { useState, useEffect } from "react";
import { IconButton, StandardButton } from "../atoms/buttons";
import { TitleAtom } from "../atoms/titleAtom";
import { HorizontalLayout } from "../components/layout";
import { icon } from "../functions/icons";
import { IconText } from "../components/courseComp";
import { GridLayout } from "../components/layout";

export function TitleAction({ProfileClassName = "", title, className, buttonTitle, buttonChildren, titleClass, buttonClass, onClick, style, editable =false, onRename, goBack, hideBtn }) {
    const [editing, setEditing] = useState(false);
    const [inputValue, setInputValue] = useState(title);

    useEffect(() => {
        setInputValue(title);
    }, [title]);

    const confirmRename = () => {
        if (inputValue.trim() !== "" && inputValue !== title && onRename) {
            onRename(inputValue.trim());
        }
        setEditing(false);
    };

    return (
        <HorizontalLayout className={`space-between standard-padding ${className}`} style={{ width: "auto", ...style }}>
            <div className={titleClass} style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                 {goBack && ( <StandardButton style={{ margin: "0", }} className={"standard-margin"} arrow={"left"} onClick={goBack} title="" />)}
                {editing ? (
                    <>
                        <input
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") confirmRename(); 
                            }}
                            autoFocus
                            className="editable-title-input"
                            style={{ fontSize: "1.5rem", fontWeight: "bold" }}
                        />
                          <IconButton onClick={() => {confirmRename();}} icon2={"check"} />
                    </>
                ) : (
                    <>
                        <TitleAtom className={ProfileClassName} title={title} />
                        {editable && (
                            <>
                            <IconButton onClick={() => setEditing(true)} icon2={"edit"} />
                            </>
                        )}
                    </>
                )}
            </div>
            <StandardButton style={{ display: hideBtn ? "none" : "block" }} onClick={onClick} className={buttonClass} title={buttonTitle}>
                {buttonChildren}
            </StandardButton>
        </HorizontalLayout>
    );
}
